import { render } from "./DevConsole.vue?vue&type=template&id=49f22b0f&scoped=true"
import script from "./DevConsole.vue?vue&type=script&lang=js"
export * from "./DevConsole.vue?vue&type=script&lang=js"

import "./DevConsole.vue?vue&type=style&index=0&id=49f22b0f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49f22b0f"]])

export default __exports__